import { z } from "zod";

/**
 * Schema de validação para planos
 * Usado em páginas CRUD de plans
 */
export const planSchema = z.object({
	name: z.string().min(1, "Nome é obrigatório").max(255, "Nome muito longo"),

	company_id: z
		.number({
			required_error: "Empresa é obrigatória",
			invalid_type_error: "Empresa inválida",
		})
		.int("Empresa inválida")
		.positive("Empresa é obrigatória"),

	value: z
		.number({
			required_error: "Valor é obrigatório",
			invalid_type_error: "Valor deve ser um número",
		})
		.nonnegative("Valor deve ser positivo"),

	description: z.string().optional().or(z.literal("")),

	icon: z.string().max(100, "Ícone muito longo").optional().or(z.literal("")),

	subtitle: z
		.string()
		.max(255, "Subtítulo muito longo")
		.optional()
		.or(z.literal("")),

	image_url: z.string().url("URL inválida").optional().or(z.literal("")),
});
